// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";

function extractVaultMetadata(metadataDict) {
  var getStr = function (key) {
    return Utils$OrcaPaymentPage.getString(metadataDict, key, "");
  };
  var config = Core__Option.getOr(metadataDict["config"], {});
  var pmSessionId = getStr("pmSessionId");
  var pmClientSecret = getStr("pmClientSecret");
  var vaultPublishableKey = getStr("vaultPublishableKey");
  var vaultProfileId = getStr("vaultProfileId");
  var endpoint = getStr("endpoint");
  var customPodUri = getStr("customPodUri");
  return {
          config: config,
          pmSessionId: pmSessionId,
          pmClientSecret: pmClientSecret,
          vaultPublishableKey: vaultPublishableKey,
          vaultProfileId: vaultProfileId,
          endpoint: endpoint,
          customPodUri: customPodUri
        };
}

export {
  extractVaultMetadata ,
}
/* Utils-OrcaPaymentPage Not a pure module */
